var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-avatar',{class:_vm.cssClass,attrs:{"size":_vm.size,"src":_vm.imageSource,"icon":"file-earmark-image","variant":"light","rounded":_vm.rounded},on:{"img-error":function($event){return _vm.$emit('imgError')}}})}
var staticRenderFns = []

export { render, staticRenderFns }